export class LocalizacaoModel{
    constructor(
        public latitude: number = 0,
        public longitude: number = 0
    )
    {}
}